exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".install-help { max-width: 520px; margin: 48px auto; padding: 24px; color: #263442; }\r\n.install-logo { display: block; width: 144px; height: auto; margin-bottom: 28px; }\r\nh1 { margin: 0 0 20px; font-size: 26px; line-height: 1.3; }\r\np { line-height: 1.65; margin-bottom: 24px; }\r\n.install-actions { display: -webkit-box; display: -ms-flexbox; display: flex; -ms-flex-wrap: wrap; flex-wrap: wrap; gap: 12px; }\r\n.btn { min-height: 44px; white-space: normal; }\r\n.btn:focus { outline: 2px solid #285f93; outline-offset: 3px; }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/pwa/pwa-install-help.component.css
// module id = ../../../../../src/app/content-page/pwa/pwa-install-help.component.css
// module chunks = main